module.exports = __webpack_public_path__ + "img/claywall_tech_Normal_ua.de925c24.webp";